import { render, staticRenderFns } from "./DashboardCreateUpdate.vue?vue&type=template&id=372937b9&scoped=true&"
import script from "./DashboardCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./DashboardCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCreateUpdate.vue?vue&type=style&index=0&id=372937b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372937b9",
  null
  
)

export default component.exports